import { init } from 'launchdarkly-node-server-sdk'

export const createClient = async key => init(key).waitForInitialization()
